var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showPagination)?_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.totalItems,"per-page":_vm.limitCount,"value":_vm.currentPage,"prev-text":"Prev","next-text":"Next"},on:{"input":_vm.onChangePage}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }